import apiFetch from '../../apiFetch'

export default function (dossierId, token) {
  return apiFetch({ endPoint: `dossier/${dossierId}/purchaseWithVehicle`, method: 'GET', token: token })
}
